import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login/Login.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    beforeEnter: (to, from, next) => {
      //
      if (!localStorage.getItem('token')) {
        next();
      } else {
        next("/Gestion-d'appel-d'offres");
      }
    },
  },
  /* Projets Views */
  {
    path: '/Gestion-iskane',
    name: 'iskane',
    component: () => import('../views/DashRoles/ProjetsViews/Iskane.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/Gestion-equipements',
    name: 'equipements',
    component: () => import('../views/DashRoles/ProjetsViews/Equipements.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/Gestion-accompagnement-social',
    name: 'accompagnement',
    component: () =>
      import('../views/DashRoles/ProjetsViews/Accompagnement.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },

  /* Medias Views */
  {
    path: '/Gestion-communiques-de-presse',
    name: 'communiques',
    component: () => import('../views/DashRoles/MediasViews/Communiques.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/Gestion-publication',
    name: 'publication',
    component: () => import('../views/DashRoles/MediasViews/Publications.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/Gestion-phototéque',
    name: 'media',
    component: () => import('../views/DashRoles/MediasViews/Media.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/Gestion-videotheque',
    name: 'media',
    component: () => import('../views/DashRoles/MediasViews/Videotheque.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  /* Lots Views */
  {
    path: '/Gestion-lots-a-vendre',
    name: 'lots',
    component: () => import('../views/DashRoles/LotsViews/Lots.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  /* Carriere Views */
  {
    path: "/Gestion-offres-d'emploi",
    name: 'demploi',
    component: () => import('../views/DashRoles/CarriereViews/Offer.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  /* Appels D'offres Views */
  {
    path: "/Gestion-d'appel-d'offres",
    name: 'offres',
    component: () => import('../views/DashRoles/AppelsViews/Appels.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  /* HomePage */
  {
    path: '/Carousel',
    name: 'Carousel',
    component: () => import('../views/DashRoles/HomePage/Carousel.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/Lots',
    name: 'Lots accueil',
    component: () => import('../views/DashRoles/HomePage/Lots.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  {
    path: '/Projets',
    name: 'Projets accueil',
    component: () => import('../views/DashRoles/HomePage/Projets.vue'),
    beforeEnter: (to, from, next) => {
      //
      if (localStorage.getItem('token')) {
        next();
      } else {
        next('/');
      }
    },
  },
  // 404 //
  {
    path: '*',
    redirect: "/Gestion-offres-d'emploi",
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
